import dayjs from "dayjs";
import { PeriodOption, PeriodResolution } from "../Metrics.types";
import { PeriodRange } from "../PeriodRange";

export function getPeriodThresholds(resolution: PeriodResolution): {
    thresholds: number[];
    suffix: string;
    label: string;
} {
    if (resolution === PeriodResolution.MONTHLY) {
        return {
            thresholds: [3, 6, 12, 24, 36, 48, 60],
            suffix: "m",
            label: "Months",
        };
    }
    if (resolution === PeriodResolution.QUARTERLY) {
        return {
            thresholds: [4, 8, 12, 16, 20],
            suffix: "q",
            label: "Quarters",
        };
    }
    return {
        thresholds: [3, 5],
        suffix: "y",
        label: "Years",
    };
}

export function getPeriodOptions(
    resolution: PeriodResolution,
    prefix: "Last" | "Next" = "Last",
): PeriodOption[] {
    const { thresholds, suffix, label } = getPeriodThresholds(resolution);
    const options: PeriodOption[] = [];
    if (resolution !== PeriodResolution.YEARLY) {
        options.push({
            id: "ytd",
            label: "Year to Date",
            resolution,
            getPeriodRange: (
                asOfDate: dayjs.Dayjs,
                metricPeriodRange: PeriodRange | null,
            ) =>
                metricPeriodRange
                    ? PeriodRange.fromArray(
                          metricPeriodRange?.getYTDPeriods(asOfDate) ?? [],
                      )
                    : null,
            isDisabled: () => false,
            threshold: null,
        });
    }
    thresholds.forEach((threshold) => {
        options.push({
            id: `${prefix.toLowerCase().charAt(0)}${threshold}${suffix}`,
            label: `${prefix} ${threshold} ${label}`,
            resolution,
            getPeriodRange: (asOfDate: dayjs.Dayjs) =>
                PeriodRange.fromDate(asOfDate, {
                    resolution,
                    windowSize: threshold,
                }) ?? null,
            isDisabled: (metricPeriodRange: PeriodRange | null) =>
                metricPeriodRange &&
                metricPeriodRange.getNumberOfPeriods(resolution) >= threshold
                    ? false
                    : true,
            threshold,
        });
    });
    options.push({
        id: "all",
        label: "All Available Data",
        resolution,
        getPeriodRange: (
            asOfDate: dayjs.Dayjs,
            metricPeriodRange: PeriodRange | null,
        ) => metricPeriodRange ?? null,
        isDisabled: () => false,
        threshold: null,
    });
    return options;
}
